import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Typography,
  TableContainer,
} from "@mui/material";
import VantageListHead from "../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  calculateAndFormatNoAbs,
  getComparator,
} from "../../../../component/Methods";
import { getValidatedTableStyles, getCellStyle } from "../../styles/rebalancerStyles";

const Target = ({ target, tableHeader }) => {
  const theme = useTheme();
  const styles = getValidatedTableStyles(theme);
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("strategy");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    if (target) {
      const formattedData = Object?.entries(target)?.map(
        ([strategy, positions]) => ({
          strategy,
          ...positions,
        })
      );
      const filteredUsers = applySortFilter(
        formattedData,
        getComparator(order, orderBy)
      );
      setData(filteredUsers);
    }
  }, [order, orderBy, target]);

  return (
    <>
      <Box sx={styles.section}>
        <Typography sx={styles.title}>Target Positions</Typography>

        <TableContainer sx={styles.tableContainer}>
          <Table
            size="small"
            stickyHeader
            aria-label="a dense table"
            sx={styles.table}
          >
            <VantageListHead
              order={order}
              orderBy={orderBy}
              headLabel={tableHeader}
              noStatus={true}
              customizeFont={12}
              rowCount={data.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {data?.map((row, index) => (
                <TableRow key={index} sx={styles.row}>
                  <Tablecell align="left" style={getCellStyle(theme, "left")}>
                    {row?.strategy}
                  </Tablecell>
                  <Tablecell align="right" style={getCellStyle(theme, "right")}>
                    {calculateAndFormatNoAbs(row?.existingNet)}
                  </Tablecell>
                  <Tablecell align="right" style={getCellStyle(theme, "right")}>
                    {calculateAndFormatNoAbs(row?.order)}
                  </Tablecell>
                  <Tablecell align="right" style={getCellStyle(theme, "right")}>
                    {calculateAndFormatNoAbs(row?.target)}
                  </Tablecell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default Target;
